import { normalizeDocumentUrl } from "./normalizeDocumentUrl";

export function isValidWebsiteUrlInput(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) {
    return true;
  }

  try {
    const parsed = new URL(normalizeDocumentUrl(trimmed));
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      return false;
    }

    const hostname = parsed.hostname;
    if (!hostname) {
      return false;
    }
    if (hostname === "localhost") {
      return true;
    }

    return hostname.includes(".");
  } catch {
    return false;
  }
}
